import { AxiosPublic } from "../../config/axios";
import React, { useCallback, useEffect, useState } from "react";
import DropDown from "../Dropdown/DropDown";
import Titel from "../DetailPaint/titel";
import { list } from './Sort'
import { useSearchParams } from "react-router-dom";

const Filters = ({ page, route }) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [data, setData] = useState()
    const [filters, setFilters] = useState({})

    useEffect(() => {
        const get = async () => {
            await AxiosPublic.get(`${route === 'painting' ? 'painting' : 'painting_with_frame'}/get-filter`)
                .then(res => setData(res.data.data))
                .catch(err => alert(err.response?.data.message || ''))
        }
        get()
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const newFilters = {};

        params.forEach((value, key) => {
            if (key === 'sort_by') {
                newFilters[key] = value;
            } else {
                newFilters[key] = value.split(',').map(val => ({ value: val }));
            }
        });
        setFilters(newFilters);
    }, []);


    const handleChange = (name, selectedItem) => {
        setFilters((prev) => {
            let updatedFilters;

            if (!selectedItem || !selectedItem.length) {
                const { [name]: _, ...remainingFilters } = prev;
                updatedFilters = remainingFilters;
            } else {
                updatedFilters = {
                    ...prev,
                    [name]: selectedItem,
                };
            }


            setSearchParams((prevParams) => {
                const params = new URLSearchParams(prevParams);
                if (page > 1) params.set('page', 1);
                if (!selectedItem || !selectedItem.length) {
                    params.delete(name);
                } else {
                    if (typeof selectedItem === 'string') {
                        params.set(name, selectedItem.toString());
                    } else {
                        params.set(name, selectedItem.map((item) => item.value).join(","));
                    }
                }

                return params;
            });

            return updatedFilters;
        });
    };



    const Filtering = useCallback((filters) => {
        let array = []
        for (const filter in filters) {
            if (Object.prototype.hasOwnProperty.call(filters, filter)) {
                const element = filters[filter];
                array.push({ ...element, name: filter })
            }
        }
        return array
    }, [])

    const makeFilter = useCallback((filters) => {
        let array = []
        for (const filter in filters) {
            if (Object.prototype.hasOwnProperty.call(filters, filter)) {
                const element = filters[filter];
                array.push({ id: element.id, name: element.title, value: element.id })
            }
        }
        return array
    }, [])


    return (
        <>
            {!!data ?
                <div className="row-span-2 bg-[#610020] flex flex-col gap-3 p-4 sm:rounded-lg">
                    <Titel title='ترتیب‌بندی براساس' className='text-white text-based' />
                    <DropDown
                        array={list} label defaultValue={filters["sort_by"]}
                        placeHolder="انتخاب" setState={handleChange} name="sort_by"
                        className='!px-3 !py-2 border border-gray-400 rounded-lg bg-white' />
                    <Titel title='فیلترها' className='text-white mt-4 text-based' />
                    {Filtering(data).map(f => {
                        return (
                            <DropDown key={f.name}
                                array={makeFilter(f.filter)} defaultValue={filters[f.name]}
                                Multiple Searchable placeHolder={f.title} setState={handleChange} name={f.name} label
                                className='!px-3 !py-2 border border-gray-400 rounded-lg bg-white' />
                        )
                    })}
                </div>
                : <p>... درحال‌ بارگذاری</p>
            }
        </>
    );
};

export default React.memo(Filters);